































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop, PropSync } from 'vue-property-decorator'
import QTable from 'quasar/src/components/table/QTable.js';
import dayjs from 'dayjs'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { InvoiceForModelCollectionModel } from '@/modules/invoice/models/invoice-for-model-collection.model'
import { PanelInvoiceRoute } from '@/modules/invoice/routes/panel-invoice.route'

@Component({
  components: { BaseButton, Modal }
})
export default class DownloadInvoiceDownloadModal extends Vue {

  constructor(private readonly routes: PanelInvoiceRoute) {
    super()
  }

  @Prop() invoiceData!: Array<InvoiceModel | InvoiceForModelCollectionModel>
  @PropSync('displayInvoiceModal') show!: boolean


  private invoiceColumns: QTable['columns'] = [
    {
      name: 'title',
      label: 'عنوان',
      field: 'title',
      align: 'left'
    },
    {
      name: 'persian_status',
      label: 'وضعیت',
      field: 'persian_status',
      align: 'left'
    },
    {
      name: 'payable',
      label: 'مبلغ قابل پرداخت',
      field: 'payable',
      align: 'left',
      format: (number) => Number(number) > -1 ? Number(number).toLocaleString() : null
    },
    {
      name: 'paid_at',
      label: 'تاریخ پرداخت',
      field: 'paid_at',
      align: 'left',
      format: number => dayjs(number).format('YYYY/MM/DD')
    },
    {
      name: 'download',
      label: 'دریافت فاکتور',
      field: 'id',
      align: 'left'
    }
  ]
}
